import React, {useCallback, useEffect, useState} from "react";
import styles from "./DestinationItem.module.scss";
import {TrashIcon} from "../../assets";
import InputMask from "react-input-mask";
import {Autocomplete, Input} from "../../ui-components";
import TimePicker from "react-time-picker";
import moment from "moment";
import {useAppDispatch, useAppSelector} from "../../core/hooks";
import {deleteDestinationCustomer} from "../requests/er-thunk";
import {Datepicker} from "../../shared";
import {CUSTOMERSREGIONS} from "../../services/constants";

const DestinationItem = ({isEditable, destination, index, lastElement}) => {
  const dispatch = useAppDispatch()

  const {
    request,
    pool,
    activePanel,
    er_call,
    insurance_org,
    emergency_responsible
  } = useAppSelector(state => state.requests)

  const [updateData, setUpdateData] = useState({
    arrival_date: moment(destination?.arrival_date).format('DD/MM/YYYY'),
    time: destination?.time,
    // waiting_time: destination?.waiting_time,
    address: destination.address,
    infoText: destination.infoText,
    city: destination.city,
  })

  useEffect(() => {
    setUpdateData({
      arrival_date: moment(destination?.arrival_date).toString(),
      time: destination?.time,
      station_info: destination?.station_info,
      address: destination.address,
      infoText: destination.infoText,
      city: destination.city,
    })
  }, [destination])

  const handleDelete = useCallback( (data) => {
    dispatch(deleteDestinationCustomer({key : data}))
  }, [dispatch])

  return <div className={styles.container}>
    <div className={styles.head} >
      <div className={styles.headWrapper} >
        {/*<AmbulanceNewIcon className='mr-5'/>*/}
        <p className={styles.title}>Адрес {index+1}</p>
        <div className={styles.title} >{request?.sentry_type}</div>
        {lastElement === index + 1 && lastElement - 1 !== 0 && !isEditable && <TrashIcon style={{cursor: "pointer"}} onClick={() => handleDelete(destination.key)}/>}
      </div>
    </div>
    <div className={styles.body}>
      <div className={styles.bodyHeadWrapper} >
        {/*<InputMask mask="99/99/9999"*/}
        {/*           maskChar=""*/}
        {/*           className={styles.input}*/}
        {/*           name='sentry_date_from'*/}
        {/*           placeholderText='ДД/ММ/ГГГГ'*/}
        {/*           error={!updateData.arrival_date}*/}
        {/*           onFocus={e => e && e.preventDefault()}*/}
        {/*           onChange={(e) => e && setUpdateData({...updateData, arrival_date: e?.target?.value})}*/}
        {/*           value={updateData.arrival_date}*/}
        {/*           disabled={isEditable}*/}
        {/*           label="Дата прибытия">*/}
        {/*  {(inputProps) => <Input disabled={isEditable} {...inputProps} />}*/}
        {/*</InputMask>*/}

        <Datepicker error={!updateData.arrival_date}
                    inputDisabled={true}
                    disableDates={new Date().toString()}
                    handleDateChange={(date) => setUpdateData({...updateData, arrival_date: date})}
                    value={updateData.arrival_date || new Date().toString()} label={"Дата прибытия"}/>
        <div style={{width: "80%",  paddingBottom: 4, borderBottom: '1px #BDC1CC solid', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 2, display: 'inline-flex'}}>
          <div style={{    position: "relative",
            marginTop: -20, alignSelf: 'stretch', color: '#505D66', fontSize: 12,  fontWeight: 500,  wordWrap: 'break-word'}}>Время прибытия</div>
          <TimePicker disabled={true}  className={[styles.timePicker]} required clearIcon secondPlaceholder={"Time"} format={"H:mm"} disableClock  onChange={(e) => setUpdateData({...updateData, time: e})} value={updateData?.time} />
        </div>
      </div>
      {/*<div style={{alignSelf: 'stretch', justifyContent: 'flex-start', gap: 16, display: 'inline-flex'}}>*/}
      {/*  /!*<div style={{width: "100%",  paddingBottom: 4, borderBottom: '1px #BDC1CC solid', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 2, display: 'inline-flex'}}>*!/*/}
      {/*  /!*  <div style={{    position: "relative",*!/*/}
      {/*  /!*    marginTop: -20, alignSelf: 'stretch', color: '#505D66', fontSize: 12,  fontWeight: 500,  wordWrap: 'break-word'}}>Ожидание на месте</div>*!/*/}
      {/*  /!*  <TimePicker disabled={true}  className={[styles.timePicker]} required clearIcon secondPlaceholder={"Time"} format={"H:mm"} disableClock  onChange={(e) => setUpdateData({...updateData, waiting_time: e})} value={updateData?.waiting_time} />*!/*/}
      {/*  /!*</div>*!/*/}
      {/*</div>*/}
      <Autocomplete className={styles.select}
                    options={CUSTOMERSREGIONS}
                    onChange={(val) =>  setUpdateData({...updateData, station_info: val?.type})}
                    optionLabel={'type'}
                    optionValue={'type'}
                    value={updateData.city}
                    disabled
                    error={!updateData.city}
                    label="Город"/>
      {updateData?.station_info && <div style={{alignSelf: 'stretch', justifyContent: 'flex-start', gap: 16, display: 'inline-flex'}}>
        <Input name='address'
               className={styles.input}
               value={updateData?.station_info}
               error={!updateData?.station_info}
               disabled={true}
               onChange={(e) => setUpdateData({...updateData, station_info: e?.target?.value})}
               label="Название стационара"/>
      </div>}
      <div style={{alignSelf: 'stretch', justifyContent: 'flex-start', gap: 16, display: 'inline-flex'}}>
        <Input name='address'
               className={styles.input}
               value={updateData?.address}
               error={!updateData?.address}
               disabled={true}
               onChange={(e) => setUpdateData({...updateData, address: e?.target?.value})}
               label="Адрес"/>
      </div>
      {updateData?.infoText && <div style={{alignSelf: 'stretch', justifyContent: 'flex-start', gap: 16, display: 'inline-flex'}}>
        <Input name='infoText'
               className={styles.input}
               value={updateData?.infoText}
               disabled={true}
               onChange={(e) => setUpdateData({...updateData, infoText: e?.target?.value})}
               label="Доп. информация"/>
      </div>}

    </div>
  </div>
}

export default DestinationItem
